module.exports = __webpack_public_path__ + "assets/icon-timeline-component.675588ea.svg";